import {
  DEFAULT_EARLIEST, DEFAULT_LATEST, DEFAULT_FUTURE_LATEST, TODAY
} from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { isPVQForm } from 'helpers/form';
import {
  foreignBenefitTypes, foreignContactFrequencyOptions, foreignInterestOwnerOptions
} from 'constants/enums/foreignActivityOptions';
import nameModelValidator from 'forms/shared/validators/models/name/name';
import { hasYesOrNo } from 'models/validate';
import { getSafeDateTime, setToStartOfMonth } from 'helpers/date';
import { ForeignActivitiesCurrentItemModel } from '../types';
// this validator is used in PVQ only - all fields apply to pvq only
export const foreignActivitiesCurrentItemValidator: ValidateJSModel<ForeignActivitiesCurrentItemModel> = {

  PersonType: (value, attributes, attributeName, options) => ({
    hasValue: {
      validator: {
        inclusion: {
          within: foreignInterestOwnerOptions,
        },
      },
    },
  }),
  Name: (value, attributes, attributeName, options) => {
    if (attributes?.PersonType?.value === 'Dependent children') {
      return {
        presence: true,
        model: { validator: nameModelValidator },
      };
    }
    return {};
  },

  BenefitType: (value, attributes, attributeName, options) => ({
    hasValue: {
      validator: {
        inclusion: {
          within: foreignBenefitTypes,
        },
      },
    },
  }),

  BenefitTypeExplanation: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitType?.value === 'Other') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  BenefitNature: (value, attributes, attributeName, options) => ({ presence: true, hasValue: { validator: hasYesOrNo } }),

  BenefitDate: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'No') {
      return {
        presence: true,
        date: {
          requireday: false,
          earliest: setToStartOfMonth(options?.applicantBirthdate) || DEFAULT_EARLIEST,
          latest: DEFAULT_LATEST,
          tooEarly: 'error.applicantMin',
        },
      };
    }

    return {};
  },

  DollarValue: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'No') {
      return {
        presence: true,
        model: { validator: currencyModelValidator },
      };
    }
    return {};
  },

  Reason: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'No') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  StartDate: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'Yes') {
      return {
        presence: true,
        date: {
          requireday: false,
          earliest: setToStartOfMonth(options?.applicantBirthdate) || DEFAULT_EARLIEST,
          latest: DEFAULT_LATEST,
          tooEarly: 'error.applicantMin',
        },
      };
    }
    return {};
  },

  EndDate: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'Yes') {
      return {
        presence: true,
        date: {
          requireday: false,
          earliest: TODAY,
          latest: DEFAULT_FUTURE_LATEST,
          tooEarly: 'error.futureBenefit.min',
        },
      };
    }
    return {};
  },

  BenefitFrequency: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'Yes') {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: foreignContactFrequencyOptions,
            },
          },
        },
      };
    }
    return {};
  },
  BenefitFrequencyExplanation: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'Yes' && attributes?.BenefitFrequency?.value === 'Other') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  TotalBenefitsValue: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'Yes') {
      return {
        presence: true,
        model: { validator: currencyModelValidator },
      };
    }
    return {};
  },
  ReceivingReason: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  FuturePlans: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'Yes') {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  FuturePlansExplanation: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitNature?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  BenefitCountry: { hasValue: true, country: { excludeUnitedStates: true } },

  BenefitObligated: (value, attributes, attributeName, options) => ({ presence: true, hasValue: { validator: hasYesOrNo } }),

  ObligatedExplanation: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitObligated?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  NotObligatedExplanation: (value, attributes, attributeName, options) => {
    if (attributes?.BenefitObligated?.value === 'No') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  CountryFocused: {},
};
